/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class YearLevelCountsTable extends Component {
  @service
  session;

  Jurisdiction = Jurisdiction;

  @alias('session.school.jurisdiction')
  jurisdiction;

  @computed('hasGenderN', 'hasGenderU')
  get colspan() {
    let colspan = 2;
    if (this.hasGenderN) {
      colspan++;
    }
    if (this.hasGenderU) {
      colspan++;
    }
    // Return stringified colspan.
    return '' + colspan;
  }
}
